import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchQuestionary({
    commit,
  }, params) {
    return axios.get(`/questionary?${formatParams(params)}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'questionary',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
};
